import { useEffect } from 'react';
import { useTriggerHandler } from '../handlers/useTriggerHandler';
import memoizeLast from 'transmute/memoizeLast';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const wrapWithHandler = memoizeLast(Comp => {
  return () => {
    const triggerHandler = useTriggerHandler();
    useEffect(() => {
      triggerHandler({
        key: 'onCardMounted',
        options: undefined
      });
    });
    if (Comp === undefined) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    return /*#__PURE__*/_jsx(Comp, {});
  };
});